import * as Yup from "yup";

export const interceptionRuleSchema = Yup.object().shape({
  ruleType: Yup.string().required("Rule type is required"),
  amountThreshold: Yup.number()
    .typeError("Must be a number")
    .min(0, "Must be 0 or greater")
    .required("Amount threshold is required"),
  startTime: Yup.string().nullable(),
  endTime: Yup.string().nullable(),
  description: Yup.string().nullable(),
  isEnabled: Yup.boolean().required(),
});

export const runtimeConfigSchema = Yup.object().shape({
  configKey: Yup.string().required("Config key is required"),
  value: Yup.string().required("Value is required"),
  valueType: Yup.string().required("Value type is required"),
  description: Yup.string().nullable(),
});